<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
// for highcharts
import Vue from "vue";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import { ModelListSelect } from "vue-search-select";
import VueApexCharts from 'vue-apexcharts'

Vue.component('apexchart', VueApexCharts)
Vue.use(HighchartsVue);
exportingInit(Highcharts);

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    ModelListSelect,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      title: "Home",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Home",
          active: true,
        },
      ],
      chartOptions: {
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "viewFullscreen",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
              ],
            },
          },
        },
        chart: {
          type: "column",
        },
        title: {
          text: "Monthly Sales Vs Expenses ",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          accessibility: {
            description: "Months of the year",
          },
        },
        yAxis: {
          title: {
            text: "Amount",
          },
          labels: {
            formatter: function () {
              return this.value;
            },
          },
        },
        tooltip: {
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1,
            },
          },
        },

        series: [
          {
            name: "Sales",
            color: "#1109ad",
            marker: {
              symbol: "square",
            },
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "Expenses",
            color: "#e612e6",
            marker: {
              symbol: "diamond",
            },
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      timeFilters: [
        { title: "Today", value: "today" },
        { title: "Select Dates", value: "custom" },
      ],
      filterData: {
        time: "today",
        from: "",
        to: "",
        branch_id: 0,
      },
      filterGraph: {
        time: "all",
        dateRange: "",
        product: 'all',
      },
      dashboardLabel: "Today's",
      donutChart: {
        series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        chartOptions: {
          labels: this.Products ?? [],
          chart: {
            height: 350,
            type: "donut",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Product Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Product Performance analysis',
                },
                png: {
                  filename: 'Product Performance analysis',
                }
              },
              autoSelected: 'zoom'
            },
          },
        },
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("analysis", ["Summary", "filterStatus", "StockAlerts"]),
    ...mapGetters("auth", ["MyUserPerm", "Branches", "branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapGetters("visualisation", ["ProductPerformance"]),
    ...mapGetters("products", ["Products"]),
  },
  // },
  methods: {
    ...mapActions({
      FetchSummary: "analysis/fetchSummary",
      FetchBraches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchGraph: "visualisation/fetchProductPerformance",
      FetchProducts: "products/fetchProducts",
    }),
    showStockAlertModal() {
      this.$refs.stockAlertModal.show();
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    assignGraph() {
      this.chartOptions.series[0].data = this.Summary
        ? this.Summary.msales
        : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.chartOptions.series[1].data = this.Summary
        ? this.Summary.mexpenses
        : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    },
    FetchSummaryData() {
      this.FetchSummary(this.filterData);
    },
    setLabel() {
      if (this.filterData.time == "today") {
        this.dashboardLabel = "Today's";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "yesterday") {
        this.dashboardLabel = "Yesterday's";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "last7") {
        this.dashboardLabel = "Last 7 days";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "last14") {
        this.dashboardLabel = "Last 14 days";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "last28") {
        this.dashboardLabel = "Last 28 days";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "month") {
        this.dashboardLabel = "This month's";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "quarter") {
        this.dashboardLabel = "This quarter's";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "custom") {
        this.filterData.from = "";
        this.filterData.to = "";
      }
    },
  },
  watch: {
    Summary(newValue) {
      if (newValue) {
        this.assignGraph();
      }
    },
    StockAlerts(newValue) {
      if (newValue) {
        if (
          this.StockAlerts.expired > 0 ||
          this.StockAlerts.short_expiry > 0 ||
          this.StockAlerts.outstock > 0 ||
          this.StockAlerts.lowstock > 0
        ) {
          this.showStockAlertModal();
        }
      }
    },
    // FIXED ProductPerformance WATCHER
    ProductPerformance(newValue) {
      if (newValue && Array.isArray(newValue)) {
        // 1. Create temporary arrays
        let newSeries = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        let newLabels = ['', '', '', '', '', '', '', '', '', '', '', ''];
        for (let i = 0; i < 12; i++) {
          if (newValue[i]) {
            newSeries[i] = parseInt(newValue[i].total_sales || 0);
            newLabels[i] = newValue[i].product_name || '';
          }
        }
        this.donutChart.series = newSeries;
        this.donutChart.chartOptions = {
          ...this.donutChart.chartOptions,
          labels: newLabels
        };
      }
    }
  },
  updated() {
    this.assignGraph();
  },

  created() {
    this.FetchSummary(this.filterData);
    this.assignGraph();
    this.FetchGeneralSettings();
    this.FetchBraches();
    this.FetchGraph(this.filterGraph);
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <div>
      <!-- <PageHeader :title="title" :items="items" /> -->
      <div class="row" v-if="MyUserPerm.view_dashboard == 1">
        <div class="col-md-3">
          <label>FILTER FOR A SPECIFIC PERIOD</label>
          <model-list-select :list="this.timeFilters ? this.timeFilters : []" v-model="filterData.time"
            option-value="value" size="sm" @input="
              setLabel();
            FetchSummaryData();
            " option-text="title" placeholder="Select Performance">
          </model-list-select>
        </div>
        <div class="col-md-3" v-show="filterData.time == 'custom'">
          <label>FROM</label>
          <input type="date" class="form-control" v-model="filterData.from" />
        </div>
        <div class="col-md-3" v-show="filterData.time == 'custom'">
          <label>To</label>
          <input type="date" class="form-control" v-model="filterData.to" />
        </div>
        <div v-if="branchid == 0" class="col-md-3 mb-3">
          <label>FILTER BY BRANCHES</label>

          <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []"
            v-model="filterData.branch_id" option-value="id" option-text="name" placeholder="Select Branch"
            @input="FetchSummaryData()">
            <option :value="0">All Branches</option>
          </model-list-select>
        </div>
        <div class="col-md-3 mt-4" align="right">
          <button class="btn"
            style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
            type="button" @click="FetchSummaryData()">
            <span class="fa fa-filter"></span> Filter
            <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
          </button>
        </div>
      </div>
      <!-- Performance Section -->
      <div class="row" v-if="MyUserPerm.view_dashboard == 1">
        <div class="col-md-12">
          <h4 class="text-center py-3">
            {{
              filterData.time === "custom"
                ? filterData.from + " - " + filterData.to
                : dashboardLabel
            }}
            Performance
          </h4>

          <div class="row" v-if="MyUserPerm.view_user_summary == 1">

            <!-- Sales Payments -->
            <div class="col-12 col-md-4 mb-3">
              <div class="card smrcard2 bg-success-custom text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-success me-3">
                    <i class="bx bx-bar-chart-alt-2"></i>
                  </div>
                  <div>
                    <h5>Sales Payments</h5>
                    <router-link to="/advanced_reports/payments" class="text-white">
                      <h4>{{ Summary.currency_code }} {{ (Summary.salesPayments || 0).toLocaleString() }}</h4>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!-- Customer Deposits -->
            <div class="col-12 col-md-4 mb-3">
              <div class="card smrcard2 bg-deposit text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-deposit me-3">
                    <i class="bx bx-receipt"></i>
                  </div>
                  <div>
                    <h5>Customer Deposits</h5>
                    <router-link to="/customer/deposits" class="text-white">
                      <h4>{{ Summary.currency_code }} {{ (Summary.customerDeposits || 0).toLocaleString() }}</h4>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!-- Expenses -->
            <div class="col-12 col-md-4 mb-3" v-if="MyUserPerm.view_expenses == 1">
              <div class="card smrcard2 bg-expense text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-expense me-3">
                    <i class="bx bx-wallet"></i>
                  </div>
                  <div>
                    <h5>Expense Payments</h5>
                    <router-link to="/expenses_report" class="text-white">
                      <h4>{{ Summary.currency_code }} {{ (Summary.expensePayments || 0).toLocaleString() }}</h4>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!-- Cash at hand -->
            <div class="col-12 col-md-4 mb-3">
              <div class="card smrcard2 bg-cash text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-cash me-3">
                    <i class="bx bx-archive-in"></i>
                  </div>
                  <div>
                    <h5>Cash at hand</h5>
                    <router-link to="/advanced_reports/transactions_report" class="text-white">
                      <h4>{{ Summary.currency_code }} {{ (Summary.cashAtHand || 0).toLocaleString() }}</h4>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!-- Net Collections -->
            <div class="col-12 col-md-4 mb-3">
              <div class="card smrcard2 bg-net text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-net me-3">
                    <i class="bx bx-line-chart"></i>
                  </div>
                  <div>
                    <h5>Net Collections</h5>
                    <router-link to="/advanced_reports/transactions_report" class="text-white">
                      <h4>{{ Summary.currency_code }} {{ (Summary.netCollections || 0).toLocaleString() }}</h4>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!-- Vehicle Deliveries -->
            <div v-if="MyUserPerm.view_vehicle_deliveries == 1 && GeneralSettings.manage_vehicles == 1"
              class="col-12 col-md-4 mb-3">
              <div class="card smrcard2 bg-vehicle text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-vehicle me-3">
                    <i class="bx bx-car"></i>
                  </div>
                  <div>
                    <h5>Vehicle Deliveries</h5>
                    <router-link to="/vehicle/deliveries/report" class="text-white">
                      <h4>{{ Summary.vehicleDeliveries || 0 }}</h4>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Business Info -->
      <div class="row" v-if="MyUserPerm.view_general_summary == 1">
        <div class="col-md-12">
          <h4 class="text-center py-3">Business Information</h4>

          <div class="row">

            <!-- Stock -->
            <div class="col-12 col-md-4 mb-3">
              <div class="card smrcard2 bg-stock text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-stock me-3">
                    <i class="bx bx-package"></i>
                  </div>
                  <div>
                    <h5>Stock Value</h5>
                    <h4>
                      {{ Summary.currency_code }}
                      {{
                        GeneralSettings.stockvalue_calculation == 0
                          ? (Summary.BuyingstockValue || 0).toLocaleString()
                          : (Summary.SellingstockValue || 0).toLocaleString()
                      }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            <!-- Commercial -->
            <div class="col-12 col-md-4 mb-3">
              <div class="card smrcard2 bg-commercial text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-commercial me-3">
                    <i class="bx bx-trending-up"></i>
                  </div>
                  <div>
                    <h5>Commercial Value</h5>
                    <h4>
                      {{ Summary.currency_code }}
                      {{
                        GeneralSettings.stockvalue_calculation == 0
                          ? (Summary.Buying_businessvalue || 0).toLocaleString()
                          : (Summary.Selling_businessvalue || 0).toLocaleString()
                      }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            <!-- Creditors -->
            <div class="col-12 col-md-4 mb-3">
              <div class="card smrcard2 bg-creditor text-white h-100">
                <div class="card-body d-flex align-items-center">
                  <div class="icon-box bg-light-creditor me-3">
                    <i class="bx bx-money"></i>
                  </div>
                  <div>
                    <h5>Creditors</h5>
                    <h4>{{ (Summary.creditors || 0).toLocaleString() }}</h4>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Business Performance Filters -->
      <div class="card mb-3" v-if="MyUserPerm.view_dashboard == 1 && MyUserPerm.view_general_summary == 1"
        style="font-size: 18px;">
        <div class="card-body">

          <div class="row g-3 align-items-end">

            <div class="col-lg-3 col-md-4">
              <label class="form-label">Filter Period</label>
              <model-list-select :list="timeFilters || []" v-model="filterData.time" option-value="value"
                option-text="title" placeholder="Select Period" @input="setLabel(); FetchSummaryData();" />
            </div>

            <div class="col-lg-2 col-md-4" v-show="filterData.time == 'custom'">
              <label class="form-label">From</label>
              <input type="date" class="form-control" v-model="filterData.from" />
            </div>

            <div class="col-lg-2 col-md-4" v-show="filterData.time == 'custom'">
              <label class="form-label">To</label>
              <input type="date" class="form-control" v-model="filterData.to" />
            </div>

            <div v-if="branchid == 0" class="col-lg-3 col-md-4">
              <label class="form-label">Branch</label>
              <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []"
                v-model="filterData.branch_id" option-value="id" option-text="name" placeholder="Select Branch"
                @input="FetchSummaryData()" />
            </div>

            <div class="col-lg-2 col-md-4">
              <button class="btn btn-primary w-100" type="button" @click="FetchSummaryData()">
                <span class="fa fa-filter"></span> Filter
                <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
              </button>
            </div>

          </div>

        </div>
      </div>

      <!-- Business Performance Table -->
      <div class="card" v-if="MyUserPerm.view_dashboard == 1 && MyUserPerm.view_general_summary == 1"
        style="font-size: 18px;">
        <div class="card-body">

          <h5 class="text-center mb-4" style="font-size: 20px;">
            {{
              filterData.time === "custom"
                ? filterData.from + " - " + filterData.to
                : dashboardLabel
            }}
            Business Performance
          </h5>
          <div class="table-responsive">
            <table class="table table-bordered table-striped align-middle">
              <thead class="table-light text-center">
                <tr>
                  <th rowspan="2" style="font-size: 18px; font-weight: bold;">Metric</th>
                  <th colspan="3" style="font-size: 18px; font-weight: bold;">Payment Channels</th>
                  <th rowspan="2" style="font-size: 18px; font-weight: bold;">Total</th>
                </tr>
                <tr>
                  <th style="font-size: 16px; font-weight: 600;">Cash</th>
                  <th style="font-size: 16px; font-weight: 600;">Bank</th>
                  <th style="font-size: 16px; font-weight: 600;">Mobile Money</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Amount Earned</th>
                  <td class="text-end">{{ Summary.cashEarned.toLocaleString() }}</td>
                  <td class="text-end">{{ Summary.bankEarned.toLocaleString() }}</td>
                  <td class="text-end">{{ Summary.mobileMoneyEarned.toLocaleString() }}</td>
                  <td class="text-end fw-bold">
                    {{
                      (Summary.cashEarned +
                        Summary.bankEarned +
                        Summary.mobileMoneyEarned).toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Amount Spent</th>
                  <td class="text-end">{{ Summary.cashSpent.toLocaleString() }}</td>
                  <td class="text-end">{{ Summary.bankSpent.toLocaleString() }}</td>
                  <td class="text-end">{{ Summary.mobileMoneySpent.toLocaleString() }}</td>
                  <td class="text-end fw-bold">
                    {{
                      (Summary.cashSpent +
                        Summary.bankSpent +
                        Summary.mobileMoneySpent).toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Balance</th>
                  <td class="text-end">{{ Summary.cashBalance.toLocaleString() }}</td>
                  <td class="text-end">{{ Summary.bankBalance.toLocaleString() }}</td>
                  <td class="text-end">{{ Summary.mobileMoneyBalance.toLocaleString() }}</td>
                  <td class="text-end fw-bold">
                    {{
                      (Summary.cashBalance +
                        Summary.bankBalance +
                        Summary.mobileMoneyBalance).toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Total Balance</th>
                  <td class="text-end">{{ Summary.totalCashBalance.toLocaleString() }}</td>
                  <td class="text-end">{{ Summary.totalBankBalance.toLocaleString() }}</td>
                  <td class="text-end">{{ Summary.totalMobileMoneyBalance.toLocaleString() }}</td>
                  <td class="text-end fw-bold">
                    {{
                      (Summary.totalCashBalance +
                        Summary.totalBankBalance +
                        Summary.totalMobileMoneyBalance).toLocaleString()
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <!-- end row -->
      <div class="row" v-if="MyUserPerm.view_dashboard == 1 && MyUserPerm.view_general_summary == 1"
        style="font-size: 18px;">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h3 class="card-title mb-4" style="font-size: 20px;"><b>Annual Analysis</b></h3>
              <div class="row text-center">
                <div class="col-sm-4">
                  <h5 class="mb-0">
                    {{ Summary ? Summary.currency_code : "" }}:
                    {{
                      Summary.totalSales
                        ? Summary.totalSales.toLocaleString()
                        : 0
                    }}
                  </h5>
                  <p class="text-muted"><b>Sales</b></p>
                </div>
                <div class="col-sm-4">
                  <h5 class="mb-0">
                    {{ Summary ? Summary.currency_code : "" }}:
                    {{
                      Summary.totalExpenses
                        ? Summary.totalExpenses.toLocaleString()
                        : 0
                    }}
                  </h5>
                  <p class="text-muted"><b>Expenses</b></p>
                </div>
                <div class="col-sm-4">
                  <h5 class="mb-0">
                    {{ Summary ? Summary.currency_code : "" }}:
                    {{
                      Summary.totalDebtors
                        ? Summary.totalDebtors.toLocaleString()
                        : 0
                    }}
                  </h5>
                  <p class="text-muted"><b>Total Debtors</b></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="MyUserPerm.view_dashboard == 1 && MyUserPerm.view_general_summary == 1">        
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">This Year's Product Sales</h4>
              <apexchart class="apex-charts" height="350" type="donut" :series="donutChart.series"
                :options="donutChart.chartOptions"></apexchart>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style type="text/css">
/* Styling for the circular icon containers */
.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-title {
  align-items: center;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.font-size-24 {
  font-size: 24px !important;
}

/* Ensure cards look consistent and don't shrink too much */
.smrcard2 {
  border: none;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  border-radius: 8px;
  transition: transform 0.2s ease-in-out;
}

.smrcard2:hover {
  transform: translateY(-2px);
}

/* Fix for mobile text overflow */
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Ensure links in cards don't look like standard blue links */
.card-body a {
  text-decoration: none !important;
}

/* CARD COLORS */
.bg-success-custom { background: #16a34a; }
.bg-deposit        { background: #0ea5a4; }
.bg-expense        { background: #ef4444; }
.bg-cash           { background: #2563eb; }
.bg-net            { background: #7c3aed; }
.bg-vehicle        { background: #1d4ed8; }
.bg-stock          { background: #0284c7; }
.bg-commercial     { background: #e612e6; }
.bg-creditor       { background: #f59e0b; }

/* ICON BOX */
.icon-box {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

/* LIGHT BACKGROUNDS */
.bg-light-success   { background: #dcfce7; color: #16a34a; }
.bg-light-deposit   { background: #ccfbf1; color: #0ea5a4; }
.bg-light-expense   { background: #fee2e2; color: #ef4444; }
.bg-light-cash      { background: #dbeafe; color: #2563eb; }
.bg-light-net       { background: #ede9fe; color: #7c3aed; }
.bg-light-vehicle   { background: #dbeafe; color: #1d4ed8; }
.bg-light-stock     { background: #e0f2fe; color: #0284c7; }
.bg-light-commercial{ background: #fce7f3; color: #e612e6; }
.bg-light-creditor  { background: #fef3c7; color: #f59e0b; }

/* TEXT */
.card h5 {
  font-size: 16px;
  margin-bottom: 5px;
}

.card h4 {
  font-weight: bold;
}

.smrcard2,
.smrcard2 h4,
.smrcard2 h5,
.smrcard2 span,
.smrcard2 a {
  color: #ffffff !important;
}
</style>